import React from 'react';
import AuditLogs from '../../gestion-audit/AuditLogs';

export default function AuditLogsMobile() { return <AuditLogs mobile />; }
